var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"payFailImg"},[_c('img',{attrs:{"src":_vm.failImg,"alt":""}})]),_c('div',{staticClass:"payFailTex"},[_c('div',[_vm._v(_vm._s(_vm.$t('PayFail'))+"!")])]),_c('div',{staticClass:"payFailbtnTex"},[_c('button',{attrs:{"id":"payFailbtn"},on:{"click":_vm.startServer}},[_vm._v(_vm._s(_vm.$t('Confirm')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }